module.exports = __webpack_public_path__ + "static/media/TgPuja.c16457b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/TgPuja.svg
// module id = 212
// module chunks = 0